import type { Components, Theme } from '@mui/material';

export const MuiListItemButton: Components<Omit<Theme, 'components'>>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      padding: '8px 22px',
    },
  },
};
